import { QREditorModalDataProps } from "@/templates/QrEditorTemplates/qr-layout/types";
import { QREditorSelectorPreviewSelectorDataProps } from "@/templates/QrEditorTemplates/qr-selector/types";

export interface QRPreviewProps {
  previewHome?: QREditorSelectorPreviewSelectorDataProps;
  previewType?: "data" | "qr" | undefined;
  previewTranslations?: any;
  isQRInit?: boolean;
  data?: any;
  isModal?: boolean;
  isQRActivated?: boolean;
  language: string;
  modalData?: QREditorModalDataProps;
}
export const PreviewSource = {
  editor: "editor",
  previewPage: "preview-page",
};
